<template>
  <div class="curriculumEdit padding-20 bgc box-shadow">
      <div class="message" v-if="!realName">
        <el-alert title="" type="warning" show-icon :closable="false">请您遵守国家相关规定，切勿上传低俗色情、暴力恐怖、谣言诈骗、侵权盗版等相关内容。</el-alert>
    </div>
    <div class="account-form form">
        <el-form :model="item" :rules="rules" ref="formName" label-width="120px" class="demo-item" label-position="left" size="mini">
            <div class="classes blod">基本信息</div>
            <el-form-item label="题库类型" prop="qbtype" required>
                <el-radio-group v-model="item.qbtype" :disabled="disabled">
                    <el-radio :label="1">单试卷</el-radio>
                    <el-radio :label="2">系列试卷</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="是否公开" prop="ispublic" required>
                <el-radio-group v-model="item.ispublic">
                    <el-radio :label="1">公开</el-radio>
                    <el-radio :label="0">不公开</el-radio>
                </el-radio-group>
                <el-popover placement="right" trigger="hover" content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
                    <div class="tipsP">
                        <p>公开：平台内的搜索、推荐都可以查询到该题库。</p>
                        <p>不公开：平台内的搜索、推荐不可以查询到该题库，只能使用题库详情分享才能查看</p>
                    </div>
                    <i class="el-icon-info" slot="reference"></i>
                </el-popover>
            </el-form-item>

            <el-form-item label="选择试卷" v-if="item.qbtype == 1" required>
                <!-- <p class="color-999">来源于内容运营部分，包括视频、音频、电子书/报告</p> -->
                <template v-if="courseinfo && courseinfo.length > 0">
                    <div class="fledx curriculum-item"  v-for="(items, index) in courseinfo" :key="index">
                        <img :src="items.eqcoverurl" :alt="items.exampapername">
                        <p>{{items.exampapername}}</p>
                        <p @click="delCourseinfo">删除</p>
                    </div>
                </template>
                <el-button v-else @click="openShopDialog">选择试卷</el-button>
            </el-form-item>

            <el-form-item label="题库名称" prop="subject" class="videoName">
                <el-input v-model.trim="item.subject" placeholder="请输入题库名称(建议字数不超过35个字)" maxlength="35" show-word-limit clearable></el-input>
            </el-form-item>
            <el-form-item label="题库简介">
                <el-input v-model="item.description" type="textarea" placeholder="请输入题库简介(不超过90个字)" maxlength="90" show-word-limit></el-input>
            </el-form-item>


            <el-form-item label="题库封面" prop="coverurl" class="upload-image" required>
                <upload class="headImage" :imgRule="imgRule"  @setImage="setCoverfile" :uploadType="uploadType" ref="coverfile"></upload>
                <div class="el-upload__tip">
                    <el-button type="warning" @click="openCoverScrollBox">素材库</el-button>
                    <div>建议尺寸750*420px，JPG、PNG格式， 图片小于5M。</div>
                </div>
            </el-form-item>
            <!--题库分类-->
            <el-form-item label="题库分类" class="addLang" required>
                    <el-cascader v-model="item.code"  :options="caseList" :props="{ expandTrigger: 'hover',value:'code',label:'name',children:'codelist',checkStrictly: true }"></el-cascader>
            </el-form-item>

            <!--所属板块-->
            <!-- <el-form-item label="所属板块" class="addLang" v-if="this.shop.ShopID=='1100021'||this.shop.ShopID=='1100006'||this.shop.ShopID=='1100005'||this.shop.ShopID=='1100829'"> -->
            <el-form-item label="所属板块" class="addLang" v-if="this.user.isofficalhost && this.user.isofficalhost==1">
                <el-select v-model="item.topicsectioncode" clearable @change="pickTopName">
                    <el-option v-for="obj in topicList" :key="obj.value" :label="obj.label" :value="obj.value">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="题库详情">
                <uEditor :content="item.content" ref="uEditor" @getUEditorContent="getUEditorContent"></uEditor>
            </el-form-item>


            <div class="classes blod">题库配置</div>

            <el-form-item label="题库价格">
                <curriculumMsg ref="curriculumMsg" @changeWay="changeWay"></curriculumMsg>
            </el-form-item>
            <el-form-item label="购买有效期" required>
                <el-radio-group v-model="item.isbuyexpire">
                    <el-radio :label="1">开启</el-radio>
                    <el-radio :label="0">关闭</el-radio>
                </el-radio-group>
                <p class="color-999">付费课程购买后在一定期限内可用</p>
                <div class="fledx subjectFlex" v-if="item.isbuyexpire == 1">
                    <p>有效期限</p><el-input v-model.number="item.expiredays" placeholder="请输入整数"></el-input><p>天</p>
                </div>
            </el-form-item>
            <el-form-item label="参与次数">
                <el-input style="width: 202px; margin-right: 12px;" placeholder="0为不限制(不限制可不填)" v-model="item.joincountbyuser"></el-input><span>次</span>
            </el-form-item>

            <div class="classes blod">上架设置</div>
            <el-form-item label="上架方式" prop="onlinetype" label-width="120px" class="onLineSet">
                <shalfSetting :item="item"></shalfSetting>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitForm">提交</el-button>
                <el-button type="" @click="cancel">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
    <scrollBox ref="coverScrollBox" :uploadType="uploadType" @saveMaterialFile="setMaterialCoverfile"></scrollBox>
    <shop ref="shop" @setShop="setShopList"></shop>

  </div>
</template>

<script>
import fecha from 'element-ui/src/utils/date'
import Upload from 'base/upload/upload'
import UEditor from 'base/uEditor/uEditor'
import CurriculumMsg from './components/curriculumMsg'
import ShalfSetting from 'base/promotionMsg/shalfSetting'
import Shop from './components/shop'
import {getQuestionbankDetail, saveOrUpdateQuesbank, getCatelist} from 'api/questionApi'
// import {videoMgtCode} from 'api/enumCode'
import {mapGetters, mapActions} from 'vuex'
import {formatCheckView, formatCheckList, formatFileInfo, computeFileSize} from 'common/js/tools'
import ScrollBox from 'base/scrollBox/scrollBox'
import {videoMsg} from 'api/message'
import $ from 'jquery'
export default {
    name: 'CurriculumEdit',
    data() {
        let validateCoverPicture = (rule, value, callback) => {
            // console.log(value)
            if (!value.furl) {
                callback(new Error('请选择课程封面'))
            } else {
                callback()
            }
        }
        let checkOnlineWay = (rule, value, callback) => {
            if (this.item.onlinetype === 2) {
                if (!this.item.onlinetime) {
                    callback(new Error('请选择上架时间'))
                } else {
                    callback()
                }
            } else {
                callback()
            }
        }
        // let validatesubClass = (rule, value, callback) => {
        //     if (this.item.code) {
        //         callback()
        //     } else {
        //         callback(new Error('请输入课程分类'))
        //     }
        // }
        return {
            caseList:[], //课程分类列表
            teachList:[], //老师列表
            topicList:[
                {value:'0101',label:'章节练习'},
                {value:'0102',label:'历年真题'},
                {value:'0103',label:'模拟试题'},
                {value:'0104',label:'易错题'},
            ],
            disabled: false,
            realName: false,
            shopGroupList: [], // 商品分组
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            dateunlockconfig: { // 日期解锁模式配置:按周期,周期类型,章节类型配置
                day: 1,
                date: 1,
                task: 1
            },

            caseListValue:[],
            item: {
                innerid: this.$route.query.qid ? this.$route.query.qid : '', // id
                qbtype : 1, // 题库类型  1单题库 2系列库
                subject: '', // 题库名称
                coverurl: {
                    bucket: '',
                    fname: '',
                    fsize: '',
                    width: '',
                    height: '',
                    key: '',
                    mimetype: '',
                    objecttype: '',
                    furl: ''
                }, // 课程封面
                description: '', // 课程简介
                // code: [],
                code: [], // 分类code
                catename: '', // 分类名称
                joincountbyuser: '',    // 可参与次数
                exampapername: '', // 试卷名称
                exampaperinnerid: '', // 试卷id
                eqcoverurl: '', // 试卷图片
                onlinetype: 1, // 上架方式
                onlinetime: '', // 定时时间
                content: '', // 题库详情
                isplatform: true,
                ispublic: 1,
                feetype: 1,
                uprice: '', // 划线价格
                saleprice: '', // 销售价格
                topicsectioncode: '', // 专题版块code
                topicsectionname: '',    // 专题版块名称
                isbuyexpire: 0, // 是否开启购买有效期
                expiredays: '0' // 有效天数
            },
            courseinfo: [], // 试卷
            rules: {
                subject: [
                    {required: true, message: '请输入名称', trigger: 'blur'},
                    {min: 1, max: 45, message: '长度在1到45个字符', trigger: 'blur'}
                ],
                // subClass: [
                //     { validator: validatesubClass, trigger: 'change' }
                //    // {required: true,type:'Array', message: '请输入课程分类', trigger: 'change'},
                // ],
                coverurl: [
                    {validator: validateCoverPicture, trigger: 'blur'}
                ],
                onlinetype: [
                    {required: true, message: '请选择上架方式', trigger: 'blur'},
                    {validator: checkOnlineWay, trigger: 'blur'}
                ],
                saleprice: [
                    {required: true, message: '请输入商品价格', trigger: 'blur'},
                    {pattern: /^[0-9]+(\.[0-9]{1,2})?$/, message: '请输入正确的价格（2位小数）', trigger: 'blur'}
                ],
                uprice: [
                    {pattern: /^[0-9]+(\.[0-9]{1,2})?$/, message: '请输入正确的价格（2位小数）', trigger: 'blur'}
                ],
            },
            imgRule: {
                cls: 'icon_upload',
                accept: 'image/png,image/jpeg',
                size: 5,
                width: '',
                height: ''
            },
        }
    },
    mounted() {
        // this._getShopGroupList()
        if (this.item.innerid) {
            this.disabled = true
            this._getView()
        }
        this._getCatelist()
    },
    methods: {
        // 所属板块传多个值
        pickTopName(e) {
            this.topicList.map((obj, i) => {
                if (obj.value == e) {
                    this.item.topicsectionname = obj.label; //传值
                    this.item.topicsectioncode = obj.value;//传值
                }
            });
        },
        // 题库分类获取
        _getCatelist(){
            console.log('获取分类')
            this.setLoading(true)
            getCatelist({
                success: data => {
                    this.setLoading(false);
                    let arr = [];
                    let arr1 = Array.from(data.data.content);
                    arr1.forEach((item,index)=>{
                        arr.push({
                            name: item.codename,
                            code: item.parentcode,
                            codelist:item.codelist
                        })
                    });
                    this.caseList = arr;
                },
                error: data => {
                    this.setLoading(false);
                    this.$message.error(data.msg)
                }
            })
        },

        // 内容列表获取
        setShopList(datalist) {
            this.courseinfo = datalist
            this.$nextTick(() => {
                this.item = this.item
            })
        },
        // 开启选择内容弹出
        openShopDialog() {
            this.$refs.shop.openDialog(this.item.datalist)
        },
        // 跳转商品分组
        goToShopGroup () {
            const _url = window.location.origin
            window.open(`${_url}/shopMgt/goods/goodsGroup`, '_blank')
        },

        // 打开课程素材库选择框
        openVideoScrollBox() {
            this.$refs.videoScrollBox.openDialog()
        },
        // 打开图片素材库选择框（封面）
        openCoverScrollBox() {
            this.$refs.coverScrollBox.openDialog()
        },
        // 设置素材库选择的图片信息（封面）
        setMaterialCoverfile(file) {
            this.item.coverurl = file;
            this.$refs.coverfile.setImage(this.item.coverurl.furl)
        },
        // 切换收费/免费
        checkFeetype(val) {
            for (let i in this.item.checkView) {
                this.item.checkView[i].status = false
            }
            // this._getShopGroupList()
        },
        // 设置封面信息（本地）
        setCoverfile(img) {
            this.item.coverurl = img
        },
        // 获取富文本编辑器内容
        getUEditorContent(content) {
            this.item.content = content
        },
        cancel() {
            this.$confirm(videoMsg.cancelEdit.msg, videoMsg.cancelEdit.title, {
                confirmButtonText: videoMsg.cancelEdit.confirmText,
                cancelButtonText: videoMsg.cancelEdit.cancelText
            }).then(() => {
                this.$router.back()
            }).catch(() => {})
        },
        submitForm() {
            let obj = JSON.parse(JSON.stringify(this.item))

            if (obj.qbtype == 1) {
                if (!this.courseinfo[0] || this.courseinfo.length == 0) {
                    this.$message.error('请选择试卷')
                        return
                } else {
                    obj.exampapername = this.courseinfo[0].exampapername // 试卷名称
                    obj.exampaperinnerid = this.courseinfo[0].exampaperinnerid // 试卷id
                    obj.eqcoverurl = this.courseinfo[0].eqcoverurl // 试卷图片
                }
            }

            if (obj.joincountbyuser == '' || obj.joincountbyuser.length == 0) {
                obj.joincountbyuser = 0 // 参与次数为空情况下默认传0
            }
            if(obj.topicsectioncode==''){
                obj.topicsectionname=''
            }

            obj.coverurl = formatFileInfo(obj.coverurl)
            obj.isplatform = obj.isplatform ? 1 : 0
            obj.ispublic = obj.ispublic ? 1 : 0

            obj.code = this.item.code[this.item.code.length-1]
            this._addObject(obj)
        },
        _addObject(obj) {
            console.log(obj)
            this.setLoading(true)
            saveOrUpdateQuesbank({
                data: obj,
                success: data => {
                    this.setLoading(false)
                    this.$message.success(videoMsg.submitEdit.successMsg)
                    // this.setPage({page: 1, pageSize: 10})

                    // 系列题库发布时弹窗提示
                    if (this.item.qbtype == 2 && !this.item.innerid) {

                        this.$confirm('恭喜您，题库发布成功！</br> 您需要前往章节设置添加试卷才能生效，快去添加吧！', '提示', {
                            dangerouslyUseHTMLString: true,
                            confirmButtonText: '前往章节设置',
                            cancelButtonText: '稍后设置'
                        }).then(() => {
                            this._gotoRouter('SubjectChapterSetUp', data.data)
                            // this.$router.push({name: 'SubjectChapterSetUp', query: {'qid': data.data}})
                            // console.log('触发1')
                        }).catch(() => {
                            this._gotoRouter('SubjectList')
                            // this.$router.push({name: 'SubjectList'})
                            // console.log('触发2')
                        })

                    } else {
                        this._gotoRouter('SubjectList')
                        //  this.$router.push({name: 'SubjectList'})
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        delCourseinfo() {
            this.courseinfo = []
            // this.$nextTick(() => {
            //     this.item = this.item
            // })
        },
        _gotoRouter(name, qid) {  // 路由跳转
            this.$router.push({name: name, query: {'qid': qid}})
        },
        _getView() { // 题库详情获取
            this.setLoading(true)
            getQuestionbankDetail({
                data: {
                    innerid: this.item.innerid
                },
                success: data => {
                    this.setLoading(false)
                    // 编辑页面内容渲染
                    this.item = data.data
                    this.$refs.uEditor.init(this.item.content)  // 详情
                    this.$refs.curriculumMsg.setItem(this.item) // 题库价格
                    this.item.isplatform = this.item.isplatform === 1   // 平台发布
                    // this.item.ispublic = this.item.ispublic === 1   // 是否公开
                    this.item.ispublic = data.data.ispublic  // 是否公开
                    this.topicList.value = data.data.topicsectioncode  // 所属板块
                    this.topicList.label = data.data.topicsectionname  // 所属板块
                    if (this.item.code) {
                        this.item.code = this.item.code.split(',')
                    }

                    this.$refs.coverfile.setImage(this.item.coverurl.furl)  // 封面

                    // 单试卷情况下
                    if (this.item.qbtype == 1) {
                        // 编辑选择试卷对象
                        this.courseinfo = [{eqcoverurl: this.item.eqcoverurl, exampaperinnerid: this.item.exampaperinnerid, exampapername: this.item.exampapername}]
                    } else {
                        this.courseinfo = []
                    }

                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setPage'
        ]),
        changeWay(type) {
            let typedata = JSON.parse(type)
            this.item.feetype = typedata.feetype
            this.item.uprice = typedata.uprice
            this.item.saleprice = typedata.saleprice
        }
    },
    filters: {},
    watch: {
        // 'feetype': {
        //     handler(newFeetype, oldFeetype) {
        //         this._getShopGroupList()
        //     }
        // },
        '$rouer': {

        },
        deep: true,
        immediate: true
    },
    computed: {
        fsize () {
            return function(size) {
                return computeFileSize(size)
            }
        },
        ...mapGetters([
            'loading',
            'user',
            'shop'
        ])
    },
    components: {
        Upload,
        UEditor,
        ScrollBox,
        CurriculumMsg,
        ShalfSetting,
        Shop
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss" scpoed>
@import "~common/scss/variable";
@import "~common/scss/mixin";
.curriculumEdit {
    .addLang .el-select,.addLang .el-input{
        width: 500px;
    }
    .el-input {
       input {
           width: 100%;
           height: 100%;
       }
    }
    .color-999 {
        font-size: 14px;
        color: #999;
    }
    .fledx {
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    }
    .subjectFlex {
        display: flex;
        align-items: center;
        .el-input{
            width: 100px;
            margin: 0 5px;
        }
    }
    .curriculum-item {
        padding: 12px;
        // margin-top: 20px;
        max-width: 810px;
        height:50px;
        box-sizing: border-box;
        background: #F5F7FA;
        p {
            max-width: 660px;
            margin-left: 20px;
            color: #303133;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;

            &:last-child {
                color: #FF4747;
                cursor: pointer;
            }
        }
        img {
            width: 46px;
            height: 26px;
        }
    }
    .setup {
        margin-bottom: 16px;
        .el-input {
            margin: 0 10px;
            width: 84px;
        }
    }
    .model-ml {
        .el-radio {
            display: block;

            p {
                color: #999999;
                font-size: 14px;
                margin-top: 15px;
            }
        }
    }

    textarea.el-textarea__inner,
    .el-textarea  {
        width: 811px;
        height: 90px;
    }
    .el-form-item.share {
        display: none;
    }
    .el-date-editor.el-input, .el-date-editor.el-input__inner {
        margin-left: 15px;
    }

    .upload-image{
        .el-form-item__content{
            @include flexBox(space-between)
        }
    }
    .account-form{
        margin-top: 20px !important;
    }
    .headImage{
        margin-right: 20px;
        .avatar-uploader{
            box-sizing: border-box;
            width: 320px;
            height: 180px;
        }
    }
    .videoName{
        .el-form-item__content{
            width: 810px;
        }
    }
    .el-upload__tip{
        width: 500px;
        color: $tcolor-grey;
        align-self: center;
        flex-grow: 1;
    }

    .shopGroup{
        .el-select{
            width: 278px;
        }
        .el-button{
            min-width: 0px;
            margin-right: 10px;
        }
        .refresh{
            margin-left: 12px;
        }
    }
}
.tipsP {
    padding: 10px;
    p {
        line-height: 20px;
    }
}
.el-icon-info{
    color: #999;
    padding-left: 10px;
    cursor: pointer;
}
</style>
